import React, { useState } from "react"
import { navigate } from "gatsby"
import PropTypes from "prop-types"
import { v4 as uuid } from "uuid"
import { addProduct, updateProduct } from "../actions/index"
import { get_perimetre, tva, echantillon_baguette, echantillon_passe_partout, echantillon_doublo, get_service_init } from "../services/prixBaguettes.js"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faShoppingBasket } from "@fortawesome/free-solid-svg-icons"
import ImgBaguette from "./imgBaguette"
import { useSelector, useDispatch } from "react-redux"
import ImgPasse from "./imgPasse"
import Img from "gatsby-image"
import { couleurs_rehausse, rehausses } from "../profcadresprix/index-legacy"
import { getPrix } from "../services/panier"

export const Panier = props => {
  let idExist = 0
  const pageProduit = useSelector(s => s.PageProduit)
  const identifiants = useSelector(s => s.identifiants).identifiants
  const panier = useSelector(s => (identifiants !== null && identifiants.mode ? s.resellerCart : s.cart))
  const dispatch = useDispatch()
  const typeP = props.product_selected.type
  const [qty, setQty] = useState(1)
  const [isAdd, setIsAdd] = useState(false)
  const [outstock, setOutstock] = useState(false)
  const [echantillon, setEchantillon] = useState(false)

  const handleSave = (event, echantillon = null) => {
    let descriptif_produit = props.product_selected.descriptif_produit

    // Descriptif doublo :
    let descriptif_doublo = ""
    if (typeP == "baguette" && pageProduit.doublo != null) {
      let ba_doublo = pageProduit.doublo
      descriptif_doublo =
        "<br />Option doublo : baguette intérieure " +
        ba_doublo.bas_reference +
        " couleur : " +
        ba_doublo?.co_libelle?.toLowerCase() +
        "<br />Largeur totale : " +
        (pageProduit.doublo.ba_largeur + props.product_selected.ba_largeur - (props.product_selected.ba_largeur - props.product_selected.ba_talon))
          .toFixed(2)
          .replace(/(\.0|0)+$/, "") +
        "cm"
      descriptif_produit += descriptif_doublo
    }
    if (typeP == "baguette" && pageProduit.cartonBarriere === true) {
      descriptif_produit += "<br /> Option carton barrière"
    }

    let descriptif_rehausse = ""
    if (pageProduit.rehausse !== null) {
      descriptif_rehausse +=
        "<br />" + rehausses[pageProduit.rehausse].title + " (couleur : " + Object.values(couleurs_rehausse)[pageProduit.rehausse_color].title + ")"
      descriptif_produit += descriptif_rehausse
    }

    if (typeof props.product_selected.pa_plaque_longueur !== "undefined") {
      descriptif_produit = getDescription()
    }
    var cadreLargeur = props.product_selected.cadreLargeur
    var cadreHauteur = props.product_selected.cadreHauteur
    let prix_produit = get_pu_ht() * tva
    var type = typeP

    var perimetre = 0
    if (props.product_selected.nameService == "longueur") {
      perimetre = 1.4
    } else {
      perimetre = get_perimetre(props.product_selected, cadreHauteur, cadreLargeur)
    }
    perimetre = perimetre * props.product_selected.ba_qty
    if (props.stock < perimetre) {
      setIsAdd(false)
      setOutstock(true)

      return false
    }

    event.preventDefault()
    idExist = 0
    panier.products.map(product => {
      /* voir si un produit existe deja dans le panier */
      if (
        product.id_product == props.product_selected.ba_id &&
        product.price == prix_produit &&
        product.largeur == props.product_selected.cadreLargeur &&
        product.hauteur == props.product_selected.cadreHauteur &&
        product.description == descriptif_produit && // Ne sert à rien sur les baguettes en soi, mais pour l'intérieur des passepartout
        product.kitMontage == (typeP == "baguette" ? pageProduit.kitMontage : null) &&
        product.carton_barriere == (typeP == "baguette" ? pageProduit.cartonBarriere : null) &&
        product.pageProduit.doublo == (typeP == "baguette" && pageProduit.doublo != null ? pageProduit.doublo : null) &&
        product.rehausse == (typeP == "baguette" ? pageProduit.rehausse : null) &&
        product.service == props.product_selected.nameService &&
        echantillon == null
      ) {
        idExist = product._id
      }
      if (echantillon != null && echantillon === "echantillon" && product.id_product == props.product_selected.ba_id && product.price == 3) {
        idExist = product._id
      }
    })

    var name_product = ""
    // name_product ça sera utiliser comme référence produit, on peut extraire la longueur et la largeur ou cas de recomandation d'une commande
    if (typeP == "passe_partout") {
      name_product = "PP-" + props.product_selected.pa_id + "-" + pageProduit.largeur + "-" + pageProduit.hauteur
    } else if (typeP == "accessoire") {
      name_product = "A-" + props.product_selected.pa_id
    } else {
      name_product = "B-" + props.product_selected.ba_id + "-" + props.product_selected.cadreLargeur + "-" + props.product_selected.cadreHauteur
    }

    if (echantillon !== null && echantillon === "echantillon") {
      if (typeP == "passe_partout") {
        name_product = "EPP-" + props.product_selected.ba_id
        prix_produit = echantillon_passe_partout
        descriptif_produit = props.product_selected.pa_reference + " - Échantillon de passe partout "
        cadreLargeur = 0
        cadreHauteur = 0
        type = "echantillon"
      } else if (typeP == "baguette") {
        name_product = "EB-" + props.product_selected.ba_id
        prix_produit = descriptif_doublo === "" ? echantillon_baguette : echantillon_doublo
        descriptif_produit =
          props.product_selected.bas_reference +
          " - Échantillon de baguette (40 cm)<br />" +
          props.product_selected.ba_descriptif +
          descriptif_rehausse +
          descriptif_doublo
        cadreLargeur = 0
        cadreHauteur = 0
        type = "echantillon"
      }
    }

    if (idExist == 0) {
      dispatch(
        addProduct({
          _id: `product_${uuid()}`,
          ba_id: props.product_selected.ba_id,
          id_product: props.product_selected.ba_id,
          reference: typeof props.product_selected.reference !== "undefined" ? props.product_selected.reference : null,
          name_product: name_product,
          price: prix_produit,
          echantillon: props.echantillon ? true : echantillon !== null && echantillon === "echantillon",
          product: { ...props.product_selected },
          description: descriptif_produit,
          qty,
          type: type,
          pageProduit: {
            ...pageProduit,
            service: pageProduit.service==='precoupe' ? 'precoupe': 'coupe_assemble_option',
            protection:['precoupe', 'coupe_assemble'].includes(pageProduit.service) ? 'aucune':pageProduit.service,
            isorel:!['coupe_assemble', 'precoupe'].includes(pageProduit.service),
            doublo: type == "baguette" && pageProduit.doublo != null ? pageProduit.doublo : null,
          },
          rehausse: type == "baguette" ? pageProduit.rehausse : null,
          dateAjout: new Date(),
        })
      )
    } else {
      dispatch(
        updateProduct({
          _id: idExist,
          qty,
        })
      )
    }

    setIsAdd(true)
    setEchantillon(echantillon !== null)
  }

  const handleUpdate = event => {
    if (event.target.value == "" || event.target.value < 1) {
      setQty(1)
    } else {
      setQty(parseInt(event.target.value))
    }
  }

  const handleCancel = () => {
    setIsAdd(false)
    setOutstock(false)
  }

  const handleNavigate = () => {
    if (typeof window !== "undefined") {
      navigate(`/panier`)
    }
  }
  const getDescription = () => {
    if (typeof props.product_selected.pa_plaque_longueur !== "undefined") {
      let description = props.product_selected.pa_description + "<br />Réf. " + props.product_selected.pa_reference + " <br /> "
      if (props.echantillon) {
        description += "<br />&Eacute;chantillon"
      } else {
        description +=
          " <br />" +
          "Dimension hors tout " +
          (pageProduit.largeur + pageProduit.pp.margeG + pageProduit.pp.margeD) +
          " x " +
          (pageProduit.hauteur + pageProduit.pp.margeH + pageProduit.pp.margeB) +
          " cm <br /> "
        description += "Dimensions de la fenêtre image : " + pageProduit.largeur + " x " + pageProduit.hauteur + " cm <br /> "
        description += "Nombre de fenêtres : " + pageProduit.pp.ouvertures[0] + " x " + pageProduit.pp.ouvertures[1] + " <br /> "
        description += "<b>Marges : </b> <br /> "
        description += "- haut : " + parseFloat(pageProduit.pp.margeH.toFixed(2)) + "cm <br /> "
        description += "- droit : " + parseFloat(pageProduit.pp.margeD.toFixed(2)) + "cm <br /> "
        description += "- bas : " + parseFloat(pageProduit.pp.margeB.toFixed(2)) + "cm <br /> "
        description += "- gauche : " + parseFloat(pageProduit.pp.margeG.toFixed(2)) + "cm <br /> "
        description += "- intérieures verticales : " + parseFloat(pageProduit.pp.interL.toFixed(2)) + "cm <br /> "
        description += "- intérieures horizontales : " + parseFloat(pageProduit.pp.interH.toFixed(2)) + "cm <br /> "
        description += "Découpe numérique dans nos ateliers de Besançon<br />"
      }
      return description
    }
  }
  const get_pu_ht = () => {
    if (typeP === "passe_partout") {
      // passe
      if (props.echantillon) return props.product_selected.prixEchantillon
      return getPrix(props.product_selected, { ...pageProduit }, [...props.produits_annexes, props.product_selected])
    }
    if (typeP !== "baguette") return parseFloat(props.product_selected.prix_produit)
    let prix = getPrix(
      props.baguette,
      { ...pageProduit, ...get_service_init()[pageProduit.service].pageProduit },

      props.produits_annexes
    )
    return parseFloat(prix)
  }
  let doublo = pageProduit.doublo == null ? { ba_largeur: 0 } : pageProduit.doublo
  return (
    <>
      <div className="columns is-vcentered">
        <div className="column">
          {typeP == "baguette" ? (
            <fieldset
              className="is-narrow"
              style={{
                boxShadow: "1px 1px 3px 3px #f0f0f0",
                padding: "1rem 2rem",
              }}
            >
              <legend
                style={{
                  textAlign: "left",
                  marginLeft: 5,
                  padding: 10,
                  fontSize: "1.2em",
                  background: "white",
                  color: "#666",
                }}
              >
                Commander un échantillon de {pageProduit.doublo !== null ? "doublo" : "baguette"}
              </legend>
              <div className="columns">
                <div className="column is-narrow">
                  <div style={{ width: 100, height: 50, overflow: "hidden", position: "relative", transform: "rotate(180deg)" }}>
                    {pageProduit.doublo !== null ? (
                      <ImgBaguette
                        className="couleurShadow"
                        type="longueur"
                        style={{
                          top: 0,
                          position: "absolute",
                          height: (doublo.ba_largeur * 50) / (doublo.ba_largeur + props.product_selected.ba_largeur),
                          transform: "rotate(180deg)",
                          width: "100%",
                        }}
                        id={pageProduit.doublo.ba_id}
                        alt={"Baguette1"}
                      />
                    ) : null}
                    <ImgBaguette
                      className="couleurShadow"
                      type="coin"
                      style={{
                        height: (props.product_selected.ba_largeur * 50) / (doublo.ba_largeur + props.product_selected.ba_largeur),
                        left: 0,
                        transform: "rotate(180deg)",
                        width: "100%",
                        position: "absolute",
                        top: (doublo.ba_largeur * 50) / (doublo.ba_largeur + props.product_selected.ba_largeur),
                      }}
                      id={props.product_selected.ba_id}
                      alt={"Baguette1"}
                    />
                  </div>
                </div>
                <div className="column">
                  <p style={{ fontSize: "1em", color: "#888", margin: 0 }}>
                    Longueur : 40cm - Tarif :{" "}
                    {new Intl.NumberFormat("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    }).format(pageProduit.doublo !== null ? 5 : 2.5 * (identifiants !== null && identifiants.mode ? 1 + identifiants.margin / 100 : 1))}{" "}
                    HT
                    <br />
                    Frais de ports <b>offerts</b> !
                  </p>
                  <button className="button" style={{ marginRight: "1rem", marginTop: "1rem" }} onClick={e => handleSave(e, "echantillon")}>
                    <FontAwesomeIcon icon={faShoppingBasket} />
                    &nbsp;&nbsp;Commander échantillon
                  </button>
                </div>
              </div>
            </fieldset>
          ) : (
            ""
          )}
        </div>

        <div className="column" style={{ fontSize: "1.2em" }}>
          {!props.echantillon && (
            <>
              <div className="field-label is-normal">
                <label htmlFor="quantite" style={{ top: 5, position: "relative" }}>
                  Quantité :
                </label>
                <input
                  type="number"
                  style={{ marginLeft: "1rem" }}
                  id="quantite"
                  name="quantite"
                  step={1}
                  value={qty}
                  onChange={handleUpdate}
                  className="input input-number"
                  min={1}
                  required
                />
              </div>
              <div className="field-label is-normal">
                <label htmlFor="quantite">
                  Total (HT) :&nbsp;
                  <b>
                    {typeP == "baguette" && pageProduit.dimensions_valid == false
                      ? "-"
                      : typeP == "accessoire"
                      ? new Intl.NumberFormat("fr-FR", {
                          style: "currency",
                          currency: "EUR",
                        }).format(qty * get_pu_ht() * (identifiants !== null && identifiants.mode ? 1 + identifiants.margin / 100 : 1))
                      : new Intl.NumberFormat("fr-FR", {
                          style: "currency",
                          currency: "EUR",
                        }).format(qty * get_pu_ht() * (identifiants !== null && identifiants.mode ? 1 + identifiants.margin / 100 : 1))}
                  </b>
                </label>
              </div>
            </>
          )}

          <button
            disabled={!!props.disabled}
            className={`button  is-primary modal-button ${props.echantillon ? "" : "is-large"}`}
            style={{ marginTop: "1rem" }}
            onClick={handleSave}
          >
            <FontAwesomeIcon icon={faShoppingBasket} />
            &nbsp;&nbsp;Ajouter au panier
          </button>
        </div>
      </div>

      <div className="modal" style={{ display: isAdd ? "flex" : "none" }}>
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <span className="modal-card-title greenArrow">
              <FontAwesomeIcon icon={faCheck} /> Produit ajouté au panier avec succès
            </span>
            <button className="delete" aria-label="close" onClick={handleCancel}></button>
          </header>
          <section className="modal-card-body">
            <div className="columns is-multiline popupPanierBorder">
              <div className="column is-5">
                {typeP == "baguette" ? (
                  <ImgBaguette id={props.product_selected.ba_id} style={{ width: 250 }} alt="photo du produit" />
                ) : typeP == "passe_partout" ? (
                  <ImgPasse style={{ width: 200, height: 200 }} className="ImgCoinPP" id={props.product_selected.pa_id} />
                ) : (
                  <Img
                    fluid={props.product_selected.mysqlImages[0].childImageSharp.fluid}
                    alt="Photo accessoire"
                    style={{ width: 200, height: 200 }}
                    className="ImgCoinPP"
                  />
                )}

                <p>
                  <strong>Prix HT : </strong>
                  {new Intl.NumberFormat("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  }).format(
                    (echantillon
                      ? typeP == "passe_partout"
                        ? echantillon_passe_partout / 1.2
                        : pageProduit.doublo !== null
                        ? echantillon_doublo
                        : echantillon_baguette
                      : get_pu_ht()) * (identifiants !== null && identifiants.mode ? 1 + identifiants.margin / 100 : 1)
                  )}
                </p>
                <p>
                  <strong>Quantité : </strong>
                  {qty}
                </p>
                <p>
                  <strong>Total HT : </strong>
                  {new Intl.NumberFormat("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  }).format(
                    qty *
                      (echantillon
                        ? typeP == "passe_partout"
                          ? echantillon_passe_partout / 1.2
                          : pageProduit.doublo !== null
                          ? echantillon_doublo
                          : echantillon_baguette
                        : get_pu_ht()) *
                      (identifiants !== null && identifiants.mode ? 1 + identifiants.margin / 100 : 1)
                  )}
                </p>
              </div>
              <div className="column is-7">
                <p
                  dangerouslySetInnerHTML={{
                    __html: typeP == "passe_partout" ? getDescription() : props.product_selected.descriptif_produit,
                  }}
                ></p>
              </div>
            </div>
          </section>
          <section className="modal-card-body">
            <p>
              <strong>Vous avez {panier.products.reduce((acc, currrent) => acc + currrent.qty, 0)} produits dans votre panier&nbsp;</strong>
            </p>
            <p>
              <strong>Total panier HT :&nbsp;</strong>
              {new Intl.NumberFormat("fr-FR", {
                style: "currency",
                currency: "EUR",
              }).format(
                panier.products.reduce((acc, currrent) => acc + (currrent.price / 1.2) * currrent.qty, 0) *
                  (identifiants !== null && identifiants.mode ? 1 + identifiants.margin / 100 : 1)
              )}
            </p>
          </section>

          <footer className="modal-card-foot">
            <button className="button" onClick={handleCancel}>
              Continuer mes achats
            </button>
            <button className="button is-success" onClick={handleNavigate}>
              Commander
            </button>
          </footer>
        </div>
      </div>
      <div
        className="modal"
        style={{
          display: !isAdd && outstock ? "flex" : "none",
        }}
      >
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Stock insuffisant pour ce cadre</p>
            <button className="delete" aria-label="close" onClick={handleCancel}></button>
          </header>
        </div>
      </div>
    </>
  )
}

Panier.defaultProps = {
  stock: 99999,
  echantillon: false,
}
Panier.propTypes = {
  product_selected: PropTypes.object,
  echantillon: PropTypes.bool,
  hauteur: PropTypes.number,
  largeur: PropTypes.number,
  produits_annexes: PropTypes.array,
  baguette: PropTypes.object,
  baguettes_doublo: PropTypes.array,
  disabled: PropTypes.string, // vide = !disabled
  stock: PropTypes.number,
}

export default Panier
